const allowJumpOverStagesReducer = (allowJumpOverStages = true, action) => {
    switch (action.type) {
        case "ADD_ALLOW_JUMP_OVER_STAGES":
            return action.payload;
        default:
            return allowJumpOverStages;
    }
};

export default allowJumpOverStagesReducer;